"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoSave = void 0;
const react_hook_form_1 = require("react-hook-form");
const use_debounce_1 = require("use-debounce");
const react_hooks_1 = require("@framework/react-hooks");
const input_registry_provider_1 = require("../input-registry-provider");
const AutoSave = props => {
    const { onSubmit, updating } = props;
    const form = (0, react_hook_form_1.useFormContext)();
    const { registeredInputs } = (0, input_registry_provider_1.useInputRegistry)();
    const { formState: { isDirty, dirtyFields }, } = form;
    const values = (0, react_hook_form_1.useWatch)();
    const debouncedOnSubmit = (0, use_debounce_1.useDebouncedCallback)(async () => {
        await onSubmit(values, form);
    }, 1000);
    (0, react_hooks_1.useDeepCompareEffect)(() => {
        if (isDirty) {
            if (registeredInputs
                .filter(input => input.isAsync)
                .some(input => !Array.isArray((0, react_hook_form_1.get)(values, input.name)) && !(0, react_hook_form_1.get)(dirtyFields, input.name))) {
                return;
            }
            void debouncedOnSubmit();
        }
    }, [values, { isDirty }, updating, registeredInputs]);
    return null;
};
exports.AutoSave = AutoSave;
//# sourceMappingURL=index.js.map